import { Platform, StyleSheet } from 'react-native';

import { colors } from '../../colors';

const cardShadow = Platform.select({
  default: {},
  android: {
    elevation: 3
  },
  ios: {
    shadowColor: colors.legendShadow,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.12,
    shadowRadius: 6
  }
});

const cardShadowWeb = {
  boxShadow: `0px 1px 4px 0px ${colors.legendShadowLayer1}, 0px 1px 2px 0px ${colors.legendShadowLayer2}, 0px 1px 6px 0px ${colors.legendShadowLayer3}`
};

const iconColumnWidth = 36;

/** Min width per item — tag column + gap + equipment name up to 10 characters on one line */
const itemMinWidth = 124;

export const styles = StyleSheet.create({
  card: {
    backgroundColor: colors.legendCardBg,
    borderRadius: 14,
    padding: 16,
    ...cardShadow,
    ...(Platform.OS === 'web' ? cardShadowWeb : {})
  },
  label: {
    color: colors.legendText,
    fontSize: 12
  },
  machineItem: {
    alignItems: 'center',
    flexDirection: 'row',
    flexShrink: 0,
    gap: 4,
    minWidth: itemMinWidth
  },
  machineLabel: {
    color: colors.legendText,
    flexShrink: 0,
    fontSize: 12
  },
  machineTag: {
    color: colors.legendText,
    flexShrink: 0,
    fontSize: 16,
    fontWeight: '700',
    textAlign: 'left'
  },
  machineTagColumn: {
    alignItems: 'flex-start',
    flexShrink: 0,
    justifyContent: 'center',
    width: iconColumnWidth
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16
  },
  rowSpacer: {
    height: 12
  },
  scroll: {
    flexGrow: 1,
    flexShrink: 1,
    minHeight: 0
  },
  scrollWeb: {
    flex: 1,
    minHeight: 0
  },
  spotIconColumn: {
    alignItems: 'flex-start',
    width: iconColumnWidth
  },
  spotItem: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 4,
    minWidth: itemMinWidth
  },
  square: {
    borderRadius: 2,
    height: 16,
    width: 16
  },
  squareFilled: {
    backgroundColor: colors.legendSelectedBg,
    borderColor: colors.legendSelectedBorder,
    borderWidth: 2
  },
  squareNonBookable: {
    backgroundColor: colors.legendNotBookableFill,
    borderColor: colors.legendNotBookableBorder,
    borderWidth: 2
  },
  squareOutlineDark: {
    backgroundColor: colors.legendCardBg,
    borderColor: colors.legendAvailableBorder,
    borderWidth: 2
  },
  squareOutlineLight: {
    backgroundColor: colors.legendCardBg,
    borderColor: colors.legendBookedBorder,
    borderWidth: 2
  }
});
